import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Button } from 'reactstrap';
import { compareVersions } from 'compare-versions';
import {
  useAppContext,
  formatMediumDate,
  callNativeMobileApp,
  useTranslator,
  withMobileAppMode,
} from '@front-activerse/common-components';

const InstacartButton = ({ categories, start, end, mobileApp }) => {
  const { trackFirebaseEvent } = useOutletContext();
  const { t } = useTranslator();
  const [preloadInstacart, setPreloadInstacart] = useState(false);

  const {
    consts: { INSTACART_FIREBASE_FUNCTION, siteMetadata },
  } = useAppContext();

  const handleInstaCart = async () => {
    const line_items = [];

    if (categories.length > 0) {
      categories.forEach((category) => {
        if (category.products.length > 0) {
          category.products.forEach((product) => {
            if (!product.isBought) {
              const measurement = product.measurements[0];

              if (measurement) {
                const unit = measurement.text.replace('%s', '').trim();
                line_items.push({
                  name: product.name.toLowerCase(),
                  display_text: product.name,
                  line_item_measurements: [
                    {
                      quantity: measurement.amount,
                      unit,
                    },
                  ],
                });
              }
            }
          });
        }
      });
    }

    const request = {
      link_type: 'shopping_list',
      name: 'Shopping list',
      line_items,
      image: '',
      instructions: [
        `Shopping list for the days: ${formatMediumDate(start)} - ${formatMediumDate(end)}`,
      ],
      author: siteMetadata.title,
      landing_page_configuration: {
        partner_linkback_url: window.location.href,
      },
    };

    setPreloadInstacart(true);

    const response = await fetch(INSTACART_FIREBASE_FUNCTION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    response.json().then((data) => {
      setPreloadInstacart(false);

      if (data.instacartUrl) {
        const instacartUrl = data.instacartUrl;

        trackFirebaseEvent('user_action', {
          action: 'tap-instacart_button',
          location: 'Shopping_list',
        });

        if (
          mobileApp &&
          mobileApp.os &&
          mobileApp.os.toLowerCase().startsWith('ios') &&
          mobileApp.version &&
          compareVersions(mobileApp.version, '4.0.2')
        ) {
          callNativeMobileApp({
            action: 'deeplink_open',
            payload: {
              url: instacartUrl,
            },
          });
        } else {
          window.location = instacartUrl;
        }
      }
    });
  };
  return (
    <div className="text-center mb-xl">
      <Button
        color="instacart"
        className="w-100"
        onClick={handleInstaCart}
        disabled={preloadInstacart}
      >
        {preloadInstacart && (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
        )}
        {t('orderIngredients.instacart.button')}
      </Button>
    </div>
  );
};

export default withMobileAppMode(InstacartButton);
